module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('img', {
    staticClass: "article-banner",
    attrs: {
      "src": require("../assets/img/article-banner.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "article-nav"
  }, [_c('li', [_vm._v("工作情感")]), _vm._v(" "), _c('li', [_vm._v("动漫文化")]), _vm._v(" "), _c('li', [_vm._v("漫画小说")]), _vm._v(" "), _c('li', [_vm._v("综合")]), _vm._v(" "), _c('li', [_vm._v("游戏")])]), _vm._v(" "), _c('img', {
    staticClass: "article-ad",
    attrs: {
      "src": require("../assets/img/article-ad.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article-content"
  }, [_c('div', {
    staticClass: "header-title cleafix"
  }, [_c('img', {
    attrs: {
      "src": "http://imgs.aixifan.com/cms/2017_03_10/1489114940717.gif?imageView2/1/w/100/h/100",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("文章推荐")])]), _vm._v(" "), _c('div', {
    staticClass: "article-sub"
  }, [_c('div', {
    staticClass: "comment fl"
  }, [_c('span', {
    staticClass: "comment-num"
  }, [_vm._v("24")]), _vm._v(" "), _c('p', [_vm._v("评论")])]), _vm._v(" "), _c('div', {
    staticClass: "sub-info"
  }, [_c('h4', {
    staticClass: "sub-title"
  }, [_vm._v("日本关西中南部8天8夜深度游(高野山、熊野三山、大阪、京都)...")]), _vm._v(" "), _c('div', {
    staticClass: "sub-user clearfix"
  }, [_c('span', {
    staticClass: "user-name fl"
  }, [_vm._v("UP主: madaomomo")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-num fr"
  }, [_vm._v("4274")])])])]), _vm._v(" "), _c('div', {
    staticClass: "article-sub"
  }, [_c('div', {
    staticClass: "comment fl"
  }, [_c('span', {
    staticClass: "comment-num"
  }, [_vm._v("161")]), _vm._v(" "), _c('p', [_vm._v("评论")])]), _vm._v(" "), _c('div', {
    staticClass: "sub-info"
  }, [_c('h4', {
    staticClass: "sub-title"
  }, [_vm._v("我说我画的是AC娘你们信吗!")]), _vm._v(" "), _c('div', {
    staticClass: "sub-user clearfix"
  }, [_c('span', {
    staticClass: "user-name fl"
  }, [_vm._v("UP主: 我是猫er")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-num fr"
  }, [_vm._v("2.9万")])])])]), _vm._v(" "), _c('div', {
    staticClass: "article-sub"
  }, [_c('div', {
    staticClass: "comment fl"
  }, [_c('span', {
    staticClass: "comment-num"
  }, [_vm._v("41")]), _vm._v(" "), _c('p', [_vm._v("评论")])]), _vm._v(" "), _c('div', {
    staticClass: "sub-info"
  }, [_c('h4', {
    staticClass: "sub-title"
  }, [_vm._v("夏日的人像祭之甜系少女")]), _vm._v(" "), _c('div', {
    staticClass: "sub-user clearfix"
  }, [_c('span', {
    staticClass: "user-name fl"
  }, [_vm._v("UP主: 俺是粽子")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-num fr"
  }, [_vm._v("1.1万")])])])]), _vm._v(" "), _c('div', {
    staticClass: "article-sub"
  }, [_c('div', {
    staticClass: "comment fl"
  }, [_c('span', {
    staticClass: "comment-num"
  }, [_vm._v("23")]), _vm._v(" "), _c('p', [_vm._v("评论")])]), _vm._v(" "), _c('div', {
    staticClass: "sub-info"
  }, [_c('h4', {
    staticClass: "sub-title"
  }, [_vm._v("简单的记录下日本简单的旅游吧")]), _vm._v(" "), _c('div', {
    staticClass: "sub-user clearfix"
  }, [_c('span', {
    staticClass: "user-name fl"
  }, [_vm._v("UP主: 小受变小攻")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-num fr"
  }, [_vm._v("4348")])])])]), _vm._v(" "), _c('div', {
    staticClass: "article-sub"
  }, [_c('div', {
    staticClass: "comment fl"
  }, [_c('span', {
    staticClass: "comment-num"
  }, [_vm._v("45")]), _vm._v(" "), _c('p', [_vm._v("评论")])]), _vm._v(" "), _c('div', {
    staticClass: "sub-info"
  }, [_c('h4', {
    staticClass: "sub-title"
  }, [_vm._v("【料理9课】姐姐的晚餐")]), _vm._v(" "), _c('div', {
    staticClass: "sub-user clearfix"
  }, [_c('span', {
    staticClass: "user-name fl"
  }, [_vm._v("UP主: 灰来灰去喵")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-num fr"
  }, [_vm._v("5638")])])])]), _vm._v(" "), _c('div', {
    staticClass: "article-sub"
  }, [_c('div', {
    staticClass: "comment fl"
  }, [_c('span', {
    staticClass: "comment-num"
  }, [_vm._v("17")]), _vm._v(" "), _c('p', [_vm._v("评论")])]), _vm._v(" "), _c('div', {
    staticClass: "sub-info"
  }, [_c('h4', {
    staticClass: "sub-title"
  }, [_vm._v("【H事】178看片")]), _vm._v(" "), _c('div', {
    staticClass: "sub-user clearfix"
  }, [_c('span', {
    staticClass: "user-name fl"
  }, [_vm._v("UP主: aliannng")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-num fr"
  }, [_vm._v("1.2万")])])])]), _vm._v(" "), _c('div', {
    staticClass: "article-sub"
  }, [_c('div', {
    staticClass: "comment fl"
  }, [_c('span', {
    staticClass: "comment-num"
  }, [_vm._v("38")]), _vm._v(" "), _c('p', [_vm._v("评论")])]), _vm._v(" "), _c('div', {
    staticClass: "sub-info"
  }, [_c('h4', {
    staticClass: "sub-title"
  }, [_vm._v("银魂642 | 戴着眼镜的家伙 变成鬼也会戴着眼镜")]), _vm._v(" "), _c('div', {
    staticClass: "sub-user clearfix"
  }, [_c('span', {
    staticClass: "user-name fl"
  }, [_vm._v("UP主: 冰块儿w")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-num fr"
  }, [_vm._v("9968")])])])]), _vm._v(" "), _c('div', {
    staticClass: "article-sub"
  }, [_c('div', {
    staticClass: "comment fl"
  }, [_c('span', {
    staticClass: "comment-num"
  }, [_vm._v("57")]), _vm._v(" "), _c('p', [_vm._v("评论")])]), _vm._v(" "), _c('div', {
    staticClass: "sub-info"
  }, [_c('h4', {
    staticClass: "sub-title"
  }, [_vm._v("2017魔都CCG一日游 (没啥小姐姐)")]), _vm._v(" "), _c('div', {
    staticClass: "sub-user clearfix"
  }, [_c('span', {
    staticClass: "user-name fl"
  }, [_vm._v("UP主: 亵渎灬依然")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-num fr"
  }, [_vm._v("1.9万")])])])]), _vm._v(" "), _c('div', {
    staticClass: "article-sub"
  }, [_c('div', {
    staticClass: "comment fl"
  }, [_c('span', {
    staticClass: "comment-num"
  }, [_vm._v("40")]), _vm._v(" "), _c('p', [_vm._v("评论")])]), _vm._v(" "), _c('div', {
    staticClass: "sub-info"
  }, [_c('h4', {
    staticClass: "sub-title"
  }, [_vm._v("闲不下来的周末——百奇花生碎饼干(伪)")]), _vm._v(" "), _c('div', {
    staticClass: "sub-user clearfix"
  }, [_c('span', {
    staticClass: "user-name fl"
  }, [_vm._v("UP主: joe你要吗")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-num fr"
  }, [_vm._v("9631")])])])]), _vm._v(" "), _c('div', {
    staticClass: "article-sub"
  }, [_c('div', {
    staticClass: "comment fl"
  }, [_c('span', {
    staticClass: "comment-num"
  }, [_vm._v("118")]), _vm._v(" "), _c('p', [_vm._v("评论")])]), _vm._v(" "), _c('div', {
    staticClass: "sub-info"
  }, [_c('h4', {
    staticClass: "sub-title"
  }, [_vm._v("骑行,青春在路上,出发了,up已经获得当事人授权,他人不得转载")]), _vm._v(" "), _c('div', {
    staticClass: "sub-user clearfix"
  }, [_c('span', {
    staticClass: "user-name fl"
  }, [_vm._v("UP主: 心情有点冷")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-num fr"
  }, [_vm._v("2.3万")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fcf0f2f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/article.vue
// module id = 111
// module chunks = 0